import { ReactComponent as EditIcon } from "../../assets/pencil-edit-button.svg";

type EditButtonProps = {
  onEdit: () => void;
};

export const EditButton = ({ onEdit }: EditButtonProps) => {
  return (
    <button className="edit-button button-link-color" onClick={onEdit}>
      <p className="edit-text">Edit</p>
      <EditIcon focusable="false" />
    </button>
  );
};
